import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"

import type {
  BatterySungageQuotePreviewDto,
  PreviewBatterySungageQuoteDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Preview a BrightStart payment. Preview does not change the saved Loan
 * Product, Quote, or Proposal Cost, so it does not invalidate price reads.
 */
export default function usePreviewBatterySungageQuote(): UseMutationResult<
  BatterySungageQuotePreviewDto,
  unknown,
  { proposalId: string; body: PreviewBatterySungageQuoteDto }
> {
  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.previewSungageQuote(proposalId, body),
  })
}
